import SectionRoomPictureList from './SectionRoomPictureList.container';

export default SectionRoomPictureList;
